import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
    name: 'getDatePipe',
    pure: true
})
export class GetDatePipe implements PipeTransform {
    // date: Date;
    transform(value: number, args?: any): any {
        return this.getDatePipe(value)
    }
    getDatePipe(date: number): String {
        if (date != null) {
            if (date.toString().length == 10) {
                const formateado = moment.unix(date).format('DD-MM-YYYY HH:mm:ss');
                return formateado;

            } else if (date.toString().length == 13) {
                const formateado = moment.unix(date / 1000).format('DD-MM-YYYY HH:mm:ss');
                return formateado;

            } else if (date.toString().length == 16) {
                const formateado = moment.unix(date / 1000000).format('DD-MM-YYYY HH:mm:ss');
                return formateado;

            } else if (date.toString().length == 19) {
                const formateado = moment.unix(date / 1000000000).format('DD-MM-YYYY HH:mm:ss');
                return formateado;

            } else {
                return 'Formato no reconocido'
            }
        } else {
            return 'Sin fecha registrada';
        }
    }
    getInvalidatedDatePipe(invalidated: number): String {
        if (invalidated != null) {
            return new Date(invalidated / 1000000).toISOString();
        } else {
            return 'Sin invalidar'
        }

    }
}